<template>
  <div id="search_container_2" ref="container">
    
  </div>
</template>
<script>


export default {
  name: "tour-Banner",
  components: { },
  mounted() {
    // this.$refs.container.style.background = "url(../img/tour.jpg)";
  },
};
</script>
<style scoped>
section {
  z-index: 1000;
}

.custom-style {
height: 112px !important;
}
</style>